import { QuotaStatus, useBilling } from "@web/hooks/useBilling"
import React, { PropsWithChildren } from "react"
import { GQL } from "platform-common/index"
import { useSession } from "next-auth/react"

export interface BillingContextValue {
  billingStatus: GQL.GetBillingStatusQueryResult["data"] | undefined
  billingStatusLoading: boolean
  getBillingStatus: () => void
  getQuotaStatus: (feature: GQL.Feature) => QuotaStatus
}

const BillingContext = React.createContext<BillingContextValue>({
  billingStatus: undefined,
  billingStatusLoading: false,
  getBillingStatus: () => null,
  getQuotaStatus: () => {
    throw new Error("getQuotaStatus not implemented")
  },
})

export const BillingProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const { getBillingStatus, billingStatus, billingStatusLoading, getQuotaStatus } = useBilling()
  const { data: session } = useSession()

  React.useEffect(() => {
    if (session?.user?.email) getBillingStatus().catch(console.error)
  }, [getBillingStatus, session?.user?.email])

  return (
    <BillingContext.Provider
      value={{ billingStatus: billingStatus, billingStatusLoading, getBillingStatus, getQuotaStatus }}
    >
      {children}
    </BillingContext.Provider>
  )
}

export const useBillingContext = () => React.useContext(BillingContext)
